import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import {
  Phone,
  PersonAdd,
  CalendarToday,
  CheckBox,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { useContactDrawer } from "components/contacts/GlobalContactDrawer";
import { COLORS } from "./constants";

export default function QuickActionsPanel() {
  const history = useHistory();
  const { openCreateContactDrawer } = useContactDrawer();

  const ACTIONS = [
    {
      label: "Log a Call",
      icon: Phone,
      color: COLORS.indigo,
      bg: "#e8eaf6",
      onClick: () => history.push("/admin/crm/contacts"),
    },
    {
      label: "Add Contact",
      icon: PersonAdd,
      color: COLORS.green,
      bg: "#e8f5e9",
      onClick: () => openCreateContactDrawer(),
    },
    {
      label: "Schedule Activity",
      icon: CalendarToday,
      color: COLORS.amber,
      bg: "#fff8e1",
      onClick: () => history.push("/admin/crm/activities?create=1"),
    },
    {
      label: "Create Task",
      icon: CheckBox,
      color: "#ab47bc",
      bg: "#f3e5f5",
      onClick: () => history.push("/admin/crm/activities?type=task"),
    },
  ];

  return (
    <Card sx={{ borderRadius: "16px", boxShadow: "0 2px 12px rgba(0,0,0,0.07)", height: "100%" }}>
      <CardContent sx={{ p: 2.5, pb: "12px !important" }}>
        <Typography variant="h6" fontWeight={700} sx={{ fontSize: "0.95rem", mb: 2 }}>
          Quick Actions
        </Typography>
        <Box
          display="grid"
          gridTemplateColumns="1fr 1fr"
          gap={1.5}
        >
          {ACTIONS.map(({ label, icon: Icon, color, bg, onClick }) => (
            <Box
              key={label}
              onClick={onClick}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                p: 2,
                borderRadius: "14px",
                bgcolor: bg,
                cursor: "pointer",
                border: "1.5px solid transparent",
                transition: "all 0.18s",
                "&:hover": {
                  borderColor: color,
                  transform: "translateY(-2px)",
                  boxShadow: `0 4px 12px ${color}33`,
                },
              }}
            >
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: "12px",
                  bgcolor: color + "22",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon sx={{ fontSize: 22, color }} />
              </Box>
              <Typography
                variant="caption"
                fontWeight={700}
                sx={{ color, textAlign: "center", lineHeight: 1.3, fontSize: "0.75rem" }}
              >
                {label}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
